"use client";

import {
  Chevron as ReactChevron,
  ChevronDown as ReactChevronDown,
  ChevronLeft as ReactChevronLeft,
  ChevronRight as ReactChevronRight,
  ChevronUp as ReactChevronUp,
} from "./deprecated/Chevron";

export const Chevron = ReactChevron;
export const ChevronDown = ReactChevronDown;
export const ChevronLeft = ReactChevronLeft;
export const ChevronRight = ReactChevronRight;
export const ChevronUp = ReactChevronUp;
